import React from "react";
import PropTypes from "prop-types";
import { Checkbox, TextInput } from "@opendate-app/setlist";
import { useMembershipProductNewContext } from "./MembershipProductNewContainer";
import { checkedFrom, ToggleField } from "./formControls";
import { DEFAULT_MAX_CHILDREN } from "./membershipFormLogic";

const GuestSettings = ({ errors }) => {
  const { membershipProduct: product, updateMembershipProduct } = useMembershipProductNewContext();
  const noLimit = product.max_children === null;

  return (
    <div className="membership-guests">
      <p className="membership-label membership-guests-label">Authorized guests</p>
      <ToggleField
        id="membership-allow-children"
        title="Allow children & grandchildren"
        description="Named on the membership, no login. Members add them at checkout; staff check them in onsite."
        checked={!!product.allow_children}
        onChange={(checked) => updateMembershipProduct({ allow_children: checked })}
      />
      {product.allow_children ? (
        <div className="membership-toggle-nested membership-guests-cap">
          <TextInput
            id="membership-max-children"
            type="number"
            min={1}
            step={1}
            label="Max children"
            disabled={noLimit}
            value={noLimit ? "" : product.max_children ?? DEFAULT_MAX_CHILDREN}
            error={errors.max_children}
            onChange={(e) => updateMembershipProduct({ max_children: e.target.value === "" ? "" : Number(e.target.value) })}
          />
          <div className="membership-guests-no-limit">
            <Checkbox
              id="membership-max-children-no-limit"
              label="No limit"
              checked={noLimit}
              onChange={(value) => updateMembershipProduct({ max_children: checkedFrom(value) ? null : DEFAULT_MAX_CHILDREN })}
            />
          </div>
        </div>
      ) : null}
      <ToggleField
        id="membership-allow-caregiver"
        title="Allow a designated caregiver"
        description="Adds one extra login for a caregiver (babysitter, grandparent), invited like any household member."
        checked={!!product.allow_caregiver}
        onChange={(checked) => updateMembershipProduct({ allow_caregiver: checked })}
      />
    </div>
  );
};

GuestSettings.propTypes = {
  errors: PropTypes.object.isRequired,
};

export default GuestSettings;
